import { Navigate, useLocation, useParams } from 'react-router-dom'
import type { PageSlug } from '../lib/routes'

/** Replace-redirects a pre-MS-818 slug (`/volume[/*]`, `/limits[/*]` — see
 * LEGACY_REDIRECTS) to its current page, keeping whatever followed it (the
 * tab segment, query and hash), so `/limits/mambu-agents` lands on
 * `/user-limits/mambu-agents` and a bare `/volume` goes through the bare
 * page's own redirect to its default tab. */
export function LegacyRedirect({ to }: Readonly<{ to: PageSlug }>) {
  const rest = useParams()['*']
  const { search, hash } = useLocation()
  const path = rest ? `/${to}/${rest}` : `/${to}`
  return <Navigate to={`${path}${search}${hash}`} replace />
}
